import React from 'react';
import { rem } from 'polished';
import moment from 'moment';
import styled from 'styled-components';
import { Button } from 'oxyrion-ui/lib';
import { __, formatDate, getServiceStatus } from '../../../Utils';
import { connect, actions } from '../../../Store';
import BaseList from '../BaseList';
import IconTd from '../../../Components/ReusableComponents/IconTd';
import ModifyService from '../../ModifyService';
import CheckAccess from '../../../ACL/CheckAccess';
import PopUpWrapper from '../../../Components/PopUpWrapper';
import HeaderFilter from '../../../Components/HeaderFilter';
import API2 from '../../../API2';

const statusEnum = {
  ALL: __('Všetky'),
  OPEN: __('Otvorené'),
  CLOSED: __('Ukončené'),
};

const P = styled.p`
  margin: 0;
  padding: 0 ${rem(10)};
  font-size: ${rem(12)};
  height: ${rem(40)};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const HeaderContentWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

class ProductItems extends BaseList {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      title: __('Helpdesk'),
      notFoundMessage: __('Nemáte vytvorené žiadne požiadavky'),
      isProduct: true,
      displayedColumns: {},
      editMode: '',
      serviceID: '',
      defaultFilter: [
        {
          id: 'type',
          values: ['helpdesk'],
        },
      ],
      status: statusEnum.OPEN,
    };

    actions.setActiveMenuItem('5');
  }

  componentDidMount() {
    this.init();
  }

  onRowClicked(index) {
    const serviceId = this.state.tableItems[index]._id;
    this.props.history.push(`/helpdesk/${serviceId}`);
  }

  init() {
    const {
      actualPage,

      offset,
      nextOffset,
      total,
    } = this.loadActualData();

    let newCheckedFilter = [];

    if (!newCheckedFilter || newCheckedFilter.length === 0) {
      newCheckedFilter = this.state.defaultFilter;
    }

    this.setState(
      {
        loading: true,
        defaultSearchText: this.props.match.params.q,
        searchText: this.props.match.params.q,
        actualPage:
          actualPage &&
          actualPage !== null &&
          actualPage !== 'null' &&
          actualPage > 0
            ? Number(actualPage)
            : 1,
        offset:
          offset && offset !== null && offset !== 'null' && offset > 0
            ? Number(offset)
            : 0,
        nextOffset:
          nextOffset &&
          nextOffset !== null &&
          nextOffset !== 'null' &&
          nextOffset > 0
            ? Number(nextOffset)
            : 0,
        total:
          total && total !== null && total !== 'null' && total > 0
            ? Number(total)
            : 0,
        checkedFilter: [...newCheckedFilter],
      },
      async () => {
        await this.fetchFilter(
          !newCheckedFilter || newCheckedFilter.length === 0,
        );
        await this.fetchData();
        this.saveActualData(1, 0, null, [], null);
      },
    );
  }

  async fetchData(parameters = {}) {
    try {
      const { searchText, checkedFilter, status } = this.state;
      this.setState({ loading: true, showProductAddedPopup: false });
      const params = parameters;

      if (searchText && searchText.length > 0) {
        params.q = searchText;
      }

      if (checkedFilter) {
        params.filters = {};
        const str = JSON.stringify({ filter: checkedFilter });
        params.filters = str;
      }

      if (status === statusEnum.ALL) {
        params.status = ['new', 'closed', 'solved', 'confirmed'];
      }
      if (status === statusEnum.OPEN) {
        params.status = ['new', 'confirmed'];
      }
      if (status === statusEnum.CLOSED) {
        params.status = ['solved', 'closed'];
      }

      const newData = await API2.getB2BHelpdeskServicesAction(params);
      this.setState({
        tableItems: newData.services,
        loading: false,
        filtersDisabled: false,
        limit: newData.limit,
        offset: newData.offset,
        total: newData.total,
        nextOffset: newData.next_offset,
      });
      this.setState({ loading: false });
    } catch (e) {
      console.log(e);
      this.setState({ error: __('Nepodarilo sa načítať faktúry') });
    }
  }
  async handleStatusChange(status) {
    if (status !== this.state.status) {
      await this.setState({
        status,
        total: '',
      });
      this.fetchData();
    }
  }

  handleSorter(s) {
    const { sorter } = this.state;
    let newSorter = sorter;
    switch (s) {
      case __('KÓD EAN'):
        if (sorter === 'Ean') {
          newSorter = '-Ean';
        } else {
          newSorter = 'Ean';
        }
        break;
      case __('PRODUKT'):
        if (sorter === 'Description') {
          newSorter = '-Description';
        } else {
          newSorter = 'Description';
        }
        break;
      case __('CENA'):
        if (sorter === 'Price') {
          newSorter = '-Price';
        } else {
          newSorter = 'Price';
        }
        break;
      default:
        newSorter = '';
        break;
    }

    this.setState({ sorter: newSorter }, () => this.fetchData());
  }

  createColumns(sorter) {
    const result = [
      {
        sortable: true,
        accessor: 'created_date',
        Header: () => (
          <IconTd
            sorter={
              sorter === 'created_date' || sorter === '-created_date'
                ? sorter
                : null
            }
          >
            {__('Zadané')}
          </IconTd>
        ),
        Cell: props => {
          return <P>{formatDate(moment(props.value))}</P>;
        },
      },
    ];

    result.push({
      sortable: true,
      accessor: 'name',
      Header: () => (
        <IconTd
          sorter={sorter === 'name' || sorter === '-name' ? sorter : null}
        >
          {__('Názov')}
        </IconTd>
      ),
      Cell: props => {
        return <P>{props.value}</P>;
      },
    });

    result.push({
      sortable: false,
      accessor: 'case',
      Header: () => <IconTd>{__('Požiadavka')}</IconTd>,
      Cell: props => {
        return <P>{props.value}</P>;
      },
    });

    result.push({
      sortable: false,
      accessor: 'machine_type',
      Header: () => <IconTd>{__('Druh')}</IconTd>,
      Cell: props => {
        return <P>{props.value}</P>;
      },
    });

    result.push({
      sortable: true,
      accessor: 'created_by',
      Header: () => (
        <IconTd
          sorter={
            sorter === 'user_name' || sorter === '-user_name' ? sorter : null
          }
        >
          {__('Vytvoril')}
        </IconTd>
      ),
      Cell: props => {
        return (
          <P>
            {props.value ? props.value.display_name : props.original.user_name}
          </P>
        );
      },
    });

    result.push({
      sortable: true,
      accessor: 'solver_name',
      Header: () => (
        <IconTd
          sorter={sorter === 'leader' || sorter === '-leader' ? sorter : null}
        >
          {__('Riešiteľ')}
        </IconTd>
      ),
      Cell: props => {
        return <P>{props.value ? props.value : '-'}</P>;
      },
    });

    result.push({
      sortable: true,
      accessor: 'status',
      Header: () => (
        <IconTd
          sorter={sorter === 'status' || sorter === '-status' ? sorter : null}
        >
          {__('Stav')}
        </IconTd>
      ),
      Cell: props => {
        return <P>{getServiceStatus(props.original)}</P>;
      },
    });

    result.push({
      sortable: true,
      accessor: 'due_date',
      Header: () => (
        <IconTd
          sorter={
            sorter === 'due_date' || sorter === '-due_date' ? sorter : null
          }
        >
          {__('Termín dokončenia')}
        </IconTd>
      ),
      Cell: props => {
        return (
          <P>{props.value ? formatDate(moment(props.value)) : __('Neznámy')}</P>
        );
      },
    });

    result.push({
      sortable: true,
      accessor: 'updated_date',
      Header: () => (
        <IconTd
          sorter={
            sorter === 'updated_date' || sorter === '-updated_date'
              ? sorter
              : null
          }
        >
          {__('Posledná zmena')}
        </IconTd>
      ),
      Cell: props => {
        return <P>{formatDate(moment(props.value))}</P>;
      },
    });

    return result;
  }

  renderCustomHeaderContent() {
    const { status, total } = this.state;
    return (
      <HeaderContentWrapper>
        <HeaderFilter
          values={[statusEnum.ALL, statusEnum.OPEN, statusEnum.CLOSED]}
          state={status}
          onClick={s => {
            this.handleStatusChange(s);
          }}
          total={total}
        />
        <CheckAccess
          operation="postB2BHelpdeskServiceAction"
          Component={
            <Button
              style={{ height: rem(15) }}
              icon="plus"
              extrasmall
              primary
              onClick={() => {
                this.props.history.push(`/helpdesk/new`);
                // this.setState({
                //   serviceID: '',
                //   editMode: 'add',
                //   showAddNewServicePopup: !this.state.showAddNewServicePopup,
                // });
              }}
            >
              {__('Vytvoriť')}
            </Button>
          }
        />
      </HeaderContentWrapper>
    );
  }

  closePopup() {
    this.setState({
      showAddNewServicePopup: false,
    });

    this.fetchData();
  }

  render() {
    const { showAddNewServicePopup, editMode, serviceID } = this.state;

    return (
      <React.Fragment>
        <PopUpWrapper
          display={showAddNewServicePopup}
          message={__('')}
          customWidth={620}
          onClose={() => this.closePopup()}
          onEscClose={() => this.closePopup()}
        >
          <ModifyService
            editMode={editMode}
            serviceID={serviceID}
            history={this.props.history}
            closePopup={() => this.closePopup()}
          />
        </PopUpWrapper>
        {super.render()}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(ProductItems);



// WEBPACK FOOTER //
// ./src/Containers/Helpdesk/List/index.jsx